import axios, { type AxiosResponse } from "axios";
import { SubscriptionItemSchema } from "@/schemas/subscription";
import type { SubscriptionItemType } from "@/schemas/subscription";
import env from "@/app/config/env";

export interface ServiceSubscriptionsApiType {
  fetchSubscriptions: () => Promise<SubscriptionItemType[]>;
  fetchSubscriptionById: (
    id: SubscriptionItemType["Id"],
  ) => Promise<SubscriptionItemType>;
  deleteSubscriptionById: (id: SubscriptionItemType["Id"]) => Promise<boolean>;
  updateSubscriptionQuantity: (
    id: SubscriptionItemType["Id"],
    quantity: number,
  ) => Promise<void>;
}

export const serviceSubscriptionsApi: ServiceSubscriptionsApiType = {
  fetchSubscriptions: () => {
    return axios
      .get(`${env.services.portal}/subscriptions`)
      .then((response: AxiosResponse<unknown[]>) => {
        return response.data.map((item: unknown) =>
          SubscriptionItemSchema.parse(item),
        );
      });
  },

  fetchSubscriptionById: (id) => {
    return axios
      .get(`${env.services.portal}/subscriptions/${id}`)
      .then((response: AxiosResponse<unknown>) => {
        return SubscriptionItemSchema.parse(response.data);
      });
  },

  deleteSubscriptionById: (id) => {
    return axios
      .delete(`${env.services.portal}/subscriptions/${id}`)
      .then(() => {
        return true;
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.Message || error.response?.data?.message;
        if (errorMessage) {
          throw new Error(errorMessage);
        }
        throw error;
      });
  },

  updateSubscriptionQuantity: (id, quantity) => {
    return axios
      .patch(`${env.services.portal}/subscriptions/${id}`, {
        quantity: quantity,
      })
      .then(() => {
        // PATCH request doesn't return data, just success status
      });
  },
};
